import { Component, Input, NgZone } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MapService } from 'src/app/Services/map.service';
import { Observable } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';

declare const mapUtilityMapBox:any;
declare var google: any;

@Component({
  selector: 'map_dropdown',
  template: `
<div class="locationField">
<div class="input-group">
  <input disabled type="text" [value]="latlngValue" class="form-control location" [title]="'Latitude,Longitude'" aria-label="Text input with segmented dropdown button">
  <div class="input-group-append">
    <button type="button" class="btn btn-outline-secondary locBtn" title="Click to selct location" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
      <i class="fas fa-map-marker-alt locIcon"></i>
    </button>
    <div class="dropdown-menu" id="dropdown" (click)="handleMenu()">
      <div class="input-group searchBox">
        <input type="search" class="form-control" id="mapSearchBox" type="search" #mapSearchBox (keyup)="mapSearchFind(mapSearchBox.value)" 
        (change)="mapSearchFind(mapSearchBox.value)" placeholder="Search" aria-label="Search" aria-describedby="basic-addon2">
        <div class="input-group-append">
          <span class="input-group-text p-2  bg-secondary text-white" id="basic-addon2"><i class="fa fa-search"></i></span>
        </div>
      </div>
      <div style="height: 100%;width: 100%" id="locationMap"></div>
    </div>
  </div>
</div>
<div *ngIf="showHint">Latitude,Longitude</div></div>`, 
  styles: [`
  .location{
    height : 48px;
    font-size : 14px;
  }
  .dropdown-toggle{
    height : 48px;
  }
  .locationField{
    height : 68.5px;
    margin : 3.5px 0px;
    padding : 0px 0px 21px;
  }
  .locBtn{
    border-radius: 0px 5px 5px 0px !important;
    padding: 10px;
  }
  .locIcon{
    font-size : 15px;
  }
  .dropdown-menu{
    position :relative;
    height : 190px;
    width : 100%;
    top : 2px !important;
    transform: translate3d(0px, 46px, 0px) !important;
    padding : 0 !important;
  }
  .searchBox{
    width: auto;
    right : 5px;
    left : 43px;
    margin-top: 5px;
    position: absolute;
    z-index: 999;
    padding: 4px;

  }
  .mapboxgl-ctrl-top-left {
    margin: 33px;
  }
  .input-group-text{
    padding: 0.375rem !importtant;
  }
  `]
})
export class MapDropdownComponent {
  @Input() field: any = {};
  @Input() form: FormGroup;
  @Input() list: any[];
  @Input() __edit: any;
  public locationMap: any;
  public markerId = 'pickLocation';
  public latValue:number;
  public lngValue:number;
  public latlngValue:any='Select Location';
  public showHint:boolean=false;
  //search
  public mapSearchDebounceTimeOut = null;
  public locationSuggestions = {};
  constructor( private mapService: MapService, ) {
  }
  ngOnInit() {
    this.initMap();
  }
  initMap() {
    this.mapService.map("locationMap").then((map) => {
      this.locationMap = map;
      this.locationMap.onMapClick(($event) => this.mapClickEventListen($event));
    }).catch((error) => {
      console.log(error)
    });
  }
  mapClickEventListen($event,locName?) {
    this.showHint=true;
    this.locationMarker($event['lngLat']['lat'], +$event['lngLat']['lng']);
  }
  locationMarker(lat, lng) {
    this.latValue=Math.round(lat * 1000000) / 1000000;
    this.lngValue=Math.round(lng * 1000000) / 1000000;
    this.latlngValue = this.latValue+','+this.lngValue;
    lat = +lat.toFixed(5); lng = +lng.toFixed(5);
    this.locationMap.marker(
      {
        id: this.markerId,
        content: '<div class="mumb_marker_pin" style="background: #686ab9;"></div>',
        lat: lat,
        lng: lng,
      }
    );
    this.locationMap.focus({
      lat: lat,
      lng: lng,
      zoom: 10
    });
  }
  mapSearchFind(location) {
    clearTimeout(this.mapSearchDebounceTimeOut);
    this.mapSearchDebounceTimeOut = setTimeout(() => {
        this.locationMap.geocoder(
          `${location}`, (res) => {
            try {
              const locations = res.features.map(function (i) { return { lat: i.center[1], lng: i.center[0], name: i.place_name } });
              this.locationMap.focus({
                lat: locations[0]['lat'],
                lng: locations[0]['lng'],
                zoom: 10
              });
              this.locationSuggestions['pickLocation'] = [];
              this.locationSuggestions['pickLocation'] = locations;
            } catch (er) { console.log(er) };
          });

    }, 1000);
  }
  handleMenu(){
    document.getElementById("dropdown").addEventListener('click', function (event) {
      event.stopPropagation();
    });
  }
}
